import React from 'react';
import { Link } from 'react-router-dom';
import './Homework4.css';

const Homework6: React.FC = () => {
  return (
    <div className="homework4-container">
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="content-wrapper">
        <Link to="/" className="back-button">
          ← Back to Hub
        </Link>

        <header className="homework4-header">
          <div className="badge">Homework 6</div>
          <h1>Image Restoration & Noise Removal</h1>
          <p className="subtitle">Add various types of noise and remove them with different filters</p>
        </header>

        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🔊</span>
            <h3>Noise Models</h3>
            <p>Gaussian, Salt & Pepper, Speckle, Poisson, Uniform, and Periodic noise</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔧</span>
            <h3>Spatial Filters</h3>
            <p>Mean, Median, Gaussian, and Bilateral filters for noise reduction</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>Frequency Domain</h3>
            <p>Butterworth Notch Reject filter for periodic noise removal</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📈</span>
            <h3>Quality Metrics</h3>
            <p>PSNR, MSE, and SSIM for quantitative evaluation</p>
          </div>
        </div>

        <div className="questions-section">
          <h2>Interactive Demo</h2>
          <div className="questions-grid">
            <Link
              to="/homework/6/main"
              className="question-card"
              style={{ '--card-color': '#f59e0b' } as React.CSSProperties}
            >
              <div className="question-number">🎨</div>
              <h3>Image Restoration Interface</h3>
              <p>Add noise to images and apply various filters to restore them. Compare results with quality metrics.</p>
              <div className="card-arrow">→</div>
            </Link>
          </div>
        </div>

        <div className="info-box" style={{ marginTop: '40px' }}>
          <h4>About This Homework</h4>
          <p>
            Image restoration is the process of recovering an original image from a degraded or noisy version. 
            This homework explores various noise models that commonly occur in imaging systems and implements 
            different filtering techniques to remove them. You can experiment with different combinations of 
            noise types and filters to understand their characteristics and effectiveness.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Homework6;


